import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { isType } from '../../../../utils/react-children-utils/react-children-utils';

const CheckboxInput = function CheckboxInput(props) {
    const {
        children,
        validation,
        invalidclass,
        defaultChecked,
    } = props;

    const [isChecked, setIsChecked] = useState(defaultChecked);

    const input = children.find((c) => isType(c, 'input'));
    const label = children.find((c) => isType(c, 'InputLabel'));

    const newInput = React.cloneElement(
        input,
        {
            onChange: (event) => {
                if (validation) {
                    validation(event);
                }
                setIsChecked(!isChecked);
            },
            className: `${input.props.className} ${invalidclass}`,
            checked: isChecked,
            'data-testid': `${input.props.name}-checkbox`,
        },
    );

    return (
        <div className={styles['checkbox-input']}>
            <div className={styles['checkbox-container']}>
                {newInput}
            </div>
            <div className={styles['checkbox-label']}>
                {label.props ? label.props.children : label}
            </div>
        </div>
    );
};

CheckboxInput.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    invalidclass: PropTypes.string,
    defaultChecked: PropTypes.string,
};

CheckboxInput.defaultProps = {
    validation: () => { },
    invalidclass: '',
    defaultChecked: '',
};

export default CheckboxInput;
